import request from '@/utils/request'
/** 1.分页获取待结算运输列表*/
export const queryPage1 = '/icps/system/sign/settlement/concrete/get_settled_consignment'
/*2.结算单查询**/
export const queryPage3 = '/icps/system/sign/settlement/concrete/getConcreteStatementInfo'
/**3.根据结算单编号获取结算单详情*/
export function get_statement_detail_by_statement_no(params) {
  return request({
    url: '/icps/system/sign/settlement/concrete/get_statement_detail_by_statement_no',
    method: 'get',
    params
  })
}
/**3.结算单，内部审核/供应商确认*/
export function generate_statement(data) {
  return request({
    url: '/icps/system/sign/settlement/concrete/update_statement',
    method: 'post',
    data
  })
}
/**4.生成结算单*/
export function generate_statement_detail(data) {
  return request({
    url: '/icps/system/sign/settlement/concrete/generate_statement_detail',
    method: 'post',
    data
  })
}
/**5.保存结算单*/
export function save_statement_detail(data) {
  return request({
    url: '/icps/system/sign/settlement/concrete/save_statement_detail',
    method: 'post',
    data
  })
}
/**6.供应商列表*/
export function QueryPage(params) {
  return request({
    url: '/icps/system/sign/settlement/concrete/query_supplier_list',
    method: 'get',
    params
  })
}
/**6.获取运距*/
export function getDetail() {
  return request({
    url: '/icps/system/sign/dataCollection/PumpPriceLog/getDetail',
    method: 'post'
  })
}









